import { IGetPollResponse } from '../../repositories/journal/v1/get-poll';
import { IPostPoll } from '../../types/postPoll';

/** Мапит структуру опроса */
export const mapPostPoll = ({ status, ...props }: IGetPollResponse): IPostPoll => ({
  pollStatus: status,
  ...props,
});
